var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.5v4m-8-4v4m-5 4h18m-16-6h14a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2v-14a2 2 0 012-2z",
    stroke: "#476FF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyMCAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0IDEuNVY1LjVNNiAxLjVWNS41TTEgOS41SDE5TTMgMy41SDE3QzE4LjEwNDYgMy41IDE5IDQuMzk1NDMgMTkgNS41VjE5LjVDMTkgMjAuNjA0NiAxOC4xMDQ2IDIxLjUgMTcgMjEuNUgzQzEuODk1NDMgMjEuNSAxIDIwLjYwNDYgMSAxOS41VjUuNUMxIDQuMzk1NDMgMS44OTU0MyAzLjUgMyAzLjVaIiBzdHJva2U9IiM0NzZGRjIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgCalendar as ReactComponent };